import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import(
	'@/views/Home')
const MoreInfo = () => import(
	'@/components/MoreInfo')
const Iframe = () => import(
	'@/views/iframe')
	const MonerisCheckout = () => import(
		'@/views/MonerisCheckout')
/* webpackChunkName: "radar" */
/* webpackMode: "lazy" */
Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '/ecotech-quebec-radar',
			alias: '/Home',
			name: 'Home',
			component: Home,
			children: [
				{
					name: 'info',
					path: ':id',
					component: MoreInfo,
					props: { cas: null, show: false }
				}]
		},
		{
			path: '/infos',
			name: 'infos',
		},
		{
			path: '/iframe',
			name: 'Iframe',
			component: Iframe
		},
		{
			path: '/moneris-checkout/:idFacture',
			name: 'MonerisCheckout',
			component: MonerisCheckout
		}
	]
})
